// Active/embedding tags only — preserves rich-text content incl. images
export const LEARNER_CONTENT_FORBIDDEN_TAGS = [
  'script',
  'iframe',
  'object',
  'embed',
  'base',
  'frame',
  'frameset',
  'meta',
  'link',
  'head',
  'html',
  'body',
  'title',
];
